<template>
  <section>
    <Title :title-name="title.RebookDly.titleName" :title-link="title.RebookDly.titleLink" />
    <div class="rebook-dly">
      <div class="container">
        <div style="margin: 14pt 0">
          Unfortunately we had to cancel your flight due to technical reasons, we can offer you the below alternatives to get you
          to the final destination.
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">OPTION 1 REBOOK YOUR FLIGHT TO FIRST AVAILABLE OPTION</h3>
        </div>
      </div>
      <div class="container">
        <div style="margin: 14pt 0">We have the following available alternative flights to your destination.</div>

        <div v-if="FlightsSameRoute && FlightsSameRoute.length > 0">
          <div v-for="(item, key) in FlightsSameRoute" :key="key" class="listFlight">
            <div
              v-if="moment(item.flight_date).diff(moment(pax.flight_date), 'days') >= 0"
              class="block-item row"
              style="margin-bottom: 15pt"
            >
              <div class="container">
                <div class="row flightinfo text-center">
                  <div class="col-4">
                    <div>From</div>
                    <div class="airport-name">{{ item.dep }}</div>
                    <div class="flight-time-der">
                      <div>
                        <i class="fas fa-circle" style="color: rgb(7, 188, 236)"> </i>
                        {{ moment(item.std).format('D MMM') }} <br />
                        {{ moment(item.std).format('H:mmA') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="frame-flight-img" style="margin-top: 11pt">
                      <img src="@/assets/images/flight.png" />
                    </div>
                    <div class="flight-status">
                      <p style="color: #000">Status: <span>On time</span></p>
                    </div>
                    <div class="text-center" style="margin-top: 15pt">
                      <a class="btnDefault" @click="updateNewFlight(item.id)">Accept</a>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>To</div>
                    <div class="airport-name">{{ item.arr }}</div>
                    <div class="flight-time-arr">
                      <div>
                        <i class="fas fa-circle" style="color: rgb(84, 206, 174)"> </i>
                        {{ moment(item.sta).format('D MMM') }} <br />
                        {{ moment(item.sta).format('H:mmA') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="moment(item.flight_date).diff(moment(pax.flight_date), 'days') >= 0"
              class="or"
              style="margin-bottom: 15pt; text-align: center"
            >
              OR
            </div>
          </div>
        </div>

        <div class="block-item row" style="margin-bottom: 15pt">
          <div class="text-center" style="margin: 15pt auto">
            <a style="display: block" href="javascript:void(0);" class="btnDefault other-date">
              <span class="collapse">Collapse</span>Other date
            </a>
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">OPTION 2 REQUEST AN REFUND SO YOU CAN TRAVEL ANOTHER DAY</h3>
        </div>
      </div>
      <div class="container">
        Request an refund voucher so I can use this on a future Jetstar booking.
        <div class="text-center" style="margin: 15pt 0">
          <a href="javascript:void(0);" class="btnDefault">Accept</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/RebookDly.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'RebookDly',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      FlightsSameRoute: 'RebookCanx/FlightsSameRoute'
    })
  },
  mounted() {
    this.$store.dispatch('RebookCanx/getFlightsSameRoute')
  },
  methods: {
    updateNewFlight: function (flightId) {
      this.$store.dispatch('RebookCanx/updateFlight', { flight_id: flightId, secret: this.secret }).then((response) => {
        if (response.success) {
          window.location.href = '/service-acceptance?secret=' + this.secret
        }
      })
    }
  }
}
</script>
